'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _StandardResponses = require('../constants/StandardResponses');

var _Units = require('../constants/Units');

exports.default = (0, _immutable.Record)({
  enabled: false,
  usingCustomResponse: false,
  standardResponse: _StandardResponses.FEW_MINUTES,
  customResponseQuantity: 5,
  customResponseUnit: _Units.MINUTES
});
module.exports = exports['default'];